import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Concierge.css";

const CATEGORIES = [
  { icon: "🍽️", label: "Restaurant", desc: "Can't get a reservation? We can." },
  { icon: "✈️", label: "Travel", desc: "Complex itinerary? We'll plan it." },
  { icon: "🎫", label: "Events", desc: "Sold out? We'll find tickets." },
  { icon: "🛍️", label: "Shopping", desc: "Gift ideas? We'll curate options." },
  { icon: "🎁", label: "Gifts", desc: "Special occasion? We'll make it memorable." },
  { icon: "🆘", label: "Emergency", desc: "Emergency abroad? We've got you." },
];

const PREVIOUS_REQUESTS = [
  { icon: "🍽️", title: "Dinner reservation at Miznon London", detail: "Mar 20, 8pm", status: "✅ Confirmed" },
  { icon: "🎫", title: "2 tickets to Hamilton London", detail: "Mar 22", status: "✅ Secured" },
  { icon: "✈️", title: "Airport transfer LHR → Mandarin Oriental", detail: "Mar 20", status: "✅ Booked" },
];

const CATEGORY_OPTIONS = ["Restaurant", "Travel", "Events", "Shopping", "Gifts", "Emergency"];

export default function Concierge() {
  const [category, setCategory] = useState("Restaurant");
  const [description, setDescription] = useState("");
  const [urgency, setUrgency] = useState("normal");
  const [contactVia, setContactVia] = useState("whatsapp");

  return (
    <div className="concierge">
      <header className="concierge-header">
        <Link to="/benefits" className="concierge-back" aria-label="Back to benefits">
          ←
        </Link>
      </header>

      <section className="concierge-hero">
        <span className="hero-emoji">🎩</span>
        <h1 className="concierge-title">Your Wish Is Our Command</h1>
        <p className="concierge-subtitle">
          24/7 personal assistance. Restaurant reservations, event tickets, travel planning — we handle everything.
        </p>
        <span className="diamond-badge">💎 Diamond Exclusive</span>
        <p className="hero-stats">
          Last month: 1,200+ requests fulfilled for eToro members 🌟
        </p>
      </section>

      <section className="quick-request-section">
        <h2 className="section-title">Quick Request</h2>
        <div className="category-grid">
          {CATEGORIES.map((cat, i) => (
            <button key={i} type="button" className="category-card">
              <span className="category-icon">{cat.icon}</span>
              <span className="category-label">{cat.label}</span>
              <span className="category-desc">{cat.desc}</span>
            </button>
          ))}
        </div>
      </section>

      <section className="new-request-section">
        <h2 className="section-title">New Request</h2>
        <form className="new-request-form" onSubmit={(e) => e.preventDefault()}>
          <div className="form-field">
            <label htmlFor="category">Category</label>
            <select
              id="category"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              {CATEGORY_OPTIONS.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </div>
          <div className="form-field">
            <label htmlFor="description">Describe what you need</label>
            <textarea
              id="description"
              placeholder="Tell us what you need..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={4}
            />
          </div>
          <div className="form-field">
            <label>Urgency</label>
            <div className="radio-group">
              <label className="radio-option">
                <input
                  type="radio"
                  name="urgency"
                  value="normal"
                  checked={urgency === "normal"}
                  onChange={(e) => setUrgency(e.target.value)}
                />
                <span>Normal</span>
              </label>
              <label className="radio-option">
                <input
                  type="radio"
                  name="urgency"
                  value="urgent"
                  checked={urgency === "urgent"}
                  onChange={(e) => setUrgency(e.target.value)}
                />
                <span>Urgent</span>
              </label>
            </div>
          </div>
          <div className="form-field">
            <label>Contact via</label>
            <div className="radio-group">
              <label className="radio-option">
                <input
                  type="radio"
                  name="contact"
                  value="whatsapp"
                  checked={contactVia === "whatsapp"}
                  onChange={(e) => setContactVia(e.target.value)}
                />
                <span>WhatsApp</span>
              </label>
              <label className="radio-option">
                <input
                  type="radio"
                  name="contact"
                  value="phone"
                  checked={contactVia === "phone"}
                  onChange={(e) => setContactVia(e.target.value)}
                />
                <span>Phone</span>
              </label>
              <label className="radio-option">
                <input
                  type="radio"
                  name="contact"
                  value="email"
                  checked={contactVia === "email"}
                  onChange={(e) => setContactVia(e.target.value)}
                />
                <span>Email</span>
              </label>
            </div>
          </div>
          <button type="submit" className="send-btn">
            Send Request
          </button>
        </form>
      </section>

      <section className="previous-requests-section">
        <h2 className="section-title">Previous Requests</h2>
        <div className="previous-list">
          {PREVIOUS_REQUESTS.map((req, i) => (
            <article key={i} className="previous-item">
              <span className="previous-icon">{req.icon}</span>
              <div className="previous-content">
                <h3 className="previous-title">{req.title}</h3>
                <p className="previous-detail">{req.detail}</p>
              </div>
              <span className="previous-status">{req.status}</span>
            </article>
          ))}
        </div>
      </section>

      <section className="direct-contact-section">
        <h2 className="section-title">Direct Contact</h2>
        <div className="contact-buttons">
          <button type="button" className="contact-btn">
            📞 Call
          </button>
          <button type="button" className="contact-btn">
            💬 WhatsApp
          </button>
          <button type="button" className="contact-btn">
            ✉️ Email
          </button>
        </div>
      </section>
    </div>
  );
}
